import clsx from 'clsx';
import Image from 'next/image';
import { Text } from '@/shared/ui';
import styles from './Placeholder.module.css';
import arrowIcon from './assets/arrow.svg';
import signIcon from './assets/sign.svg';

export const Placeholder = ({ className }: { className?: string }) => {
  return (
    <div className={clsx(styles.placeholder, className)}>
      <Image
        className={styles.arrow}
        src={arrowIcon}
        alt="arrow"
        width={184}
        height={184}
      />
      <Image
        className={styles.sign}
        src={signIcon}
        alt="sign"
        width={454}
        height={504}
      />
      <Text
        as="p"
        fontWeight={800}
        fontSize={14}
        lineHeight="24px"
        letterSpacing={-0.154}
        fontFamily="var(--font-roboto-flex)"
      >
        Смотреть всё
      </Text>
    </div>
  );
};
